import {
  baseAndroidAuthConfig,
  baseIosAuthConfig,
  baseWebAuthConfig,
} from '@sprint-expert/app/core/auth/auth-config';
import { AuthConfig } from 'angular-oauth2-oidc';

const webAuthConfig: AuthConfig = {
  ...baseWebAuthConfig,
  issuer: 'https://auth.sprintapp.team/realms/sprint-expert-app',
  userinfoEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/revoke',
  strictDiscoveryDocumentValidation: true,
  redirectUri: window.location.origin + '/',
  clientId: 'expert',
  showDebugInformation: false,
} as AuthConfig;

const iosAuthConfig = {
  ...baseIosAuthConfig,
  issuer: 'https://auth.sprintapp.team/realms/sprint-expert-app',
  userinfoEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: 'myschema://login',
  clientId: 'expert',
  showDebugInformation: false,
} as AuthConfig;

const androidAuthConfig = {
  ...baseAndroidAuthConfig,
  issuer: 'https://auth.sprintapp.team/realms/sprint-expert-app',
  userinfoEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth.sprintapp.team/realms/sprint-expert-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: 'myschema://login',
  clientId: 'expert',
  showDebugInformation: false,
} as AuthConfig;

export const environment = {
  name: 'Prod',
  title: '스프린트 코치',
  production: true,
  portOne: {
    storeId: 'store-ff34cfe4-7a68-462b-8186-ab26cd43af44',
    channelKey: 'channel-key-60bc3f96-fd1b-4a0e-839d-95f6e7bf1da2',
    noticeUrls: ['https://api.sprintapp.team/api/port-one/webhook'],
  },
  webUrl: {
    backoffice: 'https://app.sprintapp.team',
    expert: 'https://expert.sprintapp.team',
    expertManager: 'https://expert-manager.sprintapp.team',
  },
  apiBaseUrl: {
    web: 'https://api.sprintapp.team',
    ios: 'capacitor://localhost',
    android: 'http://localhost',
  },
  appsflyer: {
    memberApp: {
      baseUrl: 'https://link.spn.one/nz4h',
      links: {
        'invite-expert-member': {
          path: 'beta67tx',
        },
      },
    },
    expertApp: {
      baseUrl: 'https://e-link.spn.one/hOMO',
      links: {
        'workout-audio-recording': {
          path: 't23cwszq',
        },
      },
    },
  },
  authConfig: {
    web: webAuthConfig,
    ios: iosAuthConfig,
    android: androidAuthConfig,
  },
  authAllowedUrls: {
    web: ['https://expert.sprintapp.team/api', 'https://api.sprintapp.team'],
    ios: ['capacitor://localhost/api'],
    android: ['http://localhost/api'],
  },
  streamChat: {
    apiKey: 'zw782nazp82r',
  },
  s3Path: 'https://static.sprintapp.team',
  channelPluginKey: 'e43dc155-7cd9-4b31-ae22-105c0593d857',
  googleCalendarApiKey: 'AIzaSyCqx_aS9hSMagXSRTEcz5RR3bGYDU-dHWI',
  tldraw: {
    workerUrl: 'https://sprint-tldraw-worker-prod.developer-060.workers.dev',
  },
  imageResizeUrl: 'https://image-resize.sprintapp.team',
};
